<template>
  <div class="yy-container">
    <div class="yy-title">
      分行管理
    </div>
    <div class="yy-intro">
      分行資料會在House730網站及App顯示，同一個分行可以同時有多個組別的存在，組別的資料對分行沒有影響
    </div>
    <el-form
      ref="yyForm"
      :model="yyForm"
      :rules="rules"
      label-width="180px"
      label-position="right"
    >
      <el-form-item
        label="分行名稱:"
        prop="storeName"
      >
        <el-input
          v-model="yyForm.storeName"
          class="basc_input padr_50"
          maxlength="40"
          show-word-limit
          placeholder="中文"
        />
        <span class="yy-tag">請輸入分行中文名稱，最多40字</span>
      </el-form-item>
      <el-form-item prop="storeNameEN">
        <el-input
          v-model="yyForm.storeNameEN"
          class="basc_input padr_50"
          maxlength="60"
          show-word-limit
          placeholder="英文"
        />
        <span class="yy-tag">請輸入分行英文名稱，最多60字</span>
      </el-form-item>
      <el-form-item label="分行標籤:">
        <el-input
          v-model="yyForm.label"
          class="basc_input"
          maxlength="20"
          placeholder=""
        />
        <span class="yy-tag">添加分行標籤後，方便在列表中搜尋</span>
      </el-form-item>
      <el-form-item
        label="分行電話:"
        prop="storeTelephone"
      >
        <el-input
          v-model="yyForm.storeTelephone"
          class="basc_input"
          maxlength="8"
        />
      </el-form-item>
      <el-form-item
        label="分行地址:"
        prop="address"
      >
        <el-input
          v-model="yyForm.address"
          class="basc_input padr_50"
          maxlength="100"
          show-word-limit
          placeholder="中文"
        />
      </el-form-item>
      <el-form-item prop="addressEN">
        <el-input
          v-model="yyForm.addressEN"
          class="basc_input padr_50"
          maxlength="300"
          show-word-limit
          placeholder="英文"
        />
      </el-form-item>
      <el-form-item v-if="!$route.query.storeId">
        <el-checkbox v-model="yyForm.isDepartment">
          新增組別
        </el-checkbox>
      </el-form-item>
      <el-form-item
        v-if="yyForm.isDepartment && !$route.query.storeId"
        label="組別名稱:"
      >
        <el-input
          v-model="yyForm.storeName"
          :disabled="true"
          class="basc_input padr_50"
          maxlength="40"
          show-word-limit
          placeholder="組別名稱"
        />
      </el-form-item>
      <div class="yy-box-line" />
      <el-form-item class="yy-btns">
        <el-button
          type="primary"
          @click="submitForm('yyForm')"
        >
          儲存
        </el-button>
        <el-button @click="$router.back()">
          返回
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
    data() {
        let checkPhone = (rule, value, callback) => {
            if (!/^\d+$/.test(value) || value[0] == 0 || value[0] == 1) {
                callback(new Error('請輸入合法的聯繫方式'));
            } else {
                callback();
            }
        };
        return {
            yyForm: {
                isDepartment: true,
                storeName: '',
                storeNameEN: '',
                storeTelephone: '',
                address: '',
                addressEN: '',
                label: ''
            },
            rules: {
                storeName: [
                    {
                        required: true,
                        message: '請輸入分行名稱',
                        trigger: 'blur'
                    }
                ],
                storeNameEN: [
                    {
                        required: true,
                        message: '請輸入分行英文名稱',
                        trigger: ['blur', 'change']
                    }
                ],
                storeTelephone: [
                    {
                        required: true,
                        message: '請輸入分行聯繫方式',
                        trigger: 'blur'
                    },
                    {
                        validator: checkPhone,
                        trigger: 'blur'
                    }
                ],
                address: [
                    {
                        required: true,
                        message: '請輸入分行地址',
                        trigger: 'blur'
                    }
                ],
                addressEN: [
                    {
                        required: true,
                        message: '請輸入分行英文地址',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    created() {
        if (this.$route.query.storeId) {
            this.getDepartmentDetail(this.$route.query.storeId);
        }
    },
    methods: {
        async getDepartmentDetail(storeId) {
            const detail = await this.axios.get(this.pub.getApi().SingleStoreByStoreID + `?storeID=${storeId}`);
            if (detail.data.code == 0 && detail.data.result) {
                const res = detail.data.result;
                this.yyForm = {
                    storeName: res.storeName,
                    storeNameEN: res.storeNameEN,
                    storeTelephone: res.storeTelephone,
                    address: res.address,
                    addressEN: res.addressEN,
                    label: res.label
                };
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate(async valid => {
                if (valid) {
                    if (this.$route.query.storeId) {
                        // 更新分行接口
                        const update = await this.axios.post(this.pub.getApi().UpdateStore, {
                            companyID: this.$route.query.companyId,
                            storeID: this.$route.query.storeId,
                            storeName: this.yyForm.storeName,
                            storeNameEN: this.yyForm.storeNameEN,
                            storeTelephone: this.yyForm.storeTelephone,
                            address: this.yyForm.address,
                            addressEN: this.yyForm.addressEN,
                            label: this.yyForm.label
                        });
                        if (update.data.code == 0 && update.data.result) {
                            this.$message({
                                message: '分行資料更新成功',
                                type: 'success',
                                showClose: true
                            });
                            history.back();
                        } else if (update.data.code == 400) {
                            this.$message({
                                message: '必填項不可為空',
                                error: 'error',
                                showClose: true
                            });
                        } else {
                            this.$message({
                                message: '分行資料更新失敗',
                                error: 'error',
                                showClose: true
                            });
                        }
                    } else {
                        // 新增分行
                        const add = await this.axios.post(this.pub.getApi().AddStore, {
                            companyID: this.$route.query.companyId,
                            storeName: this.yyForm.storeName,
                            storeNameEN: this.yyForm.storeNameEN,
                            storeTelephone: this.yyForm.storeTelephone,
                            address: this.yyForm.address,
                            addressEN: this.yyForm.addressEN,
                            label: this.yyForm.label,
                            isDepartment: this.yyForm.isDepartment
                        });
                        if (add.data.code == 0 && add.data.result) {
                            this.$message({
                                message: '添加分行成功',
                                type: 'success',
                                showClose: true
                            });
                            // history.back();
                            this.$router.push('/department/index')
                        } else if (add.data.code == 400) {
                            this.$message({
                                message: '必填項不可為空',
                                type: 'error',
                                showClose: true
                            });
                        } else if (add.data.code == 2018) {
                            this.$message({
                                message: '組別已存在，添加分行失敗',
                                type: 'error',
                                showClose: true
                            });
                        } else {
                            this.$message({
                                message: '添加分行失敗',
                                error: 'error',
                                showClose: true
                            });
                        }
                    }
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.yy-container {
    text-align: left;
    border: 1px solid #ddd;
    .el-button {
        width: 88px;
        border-radius: 10px;
    }
    .yy-title {
        border-bottom: 1px solid #ddd;
        font-weight: normal;
        font-size: 20px;
        padding: 20px;
    }
    .yy-intro {
        // margin-bottom: 80px;
        padding: 20px;
    }
    .el-form {
        position: relative;
        .el-form-item {
            padding-left: 20px;
            margin-bottom: 20px;
            position: relative;
            .yy-tag {
                font-size: 14px;
                color: #666;
                margin-left: 10px;
            }
        }
        .el-form-item__label {
            font-weight: bold;
        }
        /deep/.el-input {
            width: 450px;
            .el-input__inner {
                background-color: #fafafb;
                color: #000;
                border: 1px solid rgba(219, 219, 219, 1);
                border-radius: 15px;
                &::placeholder {
                    color: #666;
                }
            }
        }
        .padr_50{
            /deep/.el-input__inner{
                padding-right: 53px;
            }
        }
        .yy-btns {
            padding: 20px;
            margin-bottom: 0px;
            .el-form-item__content {
                margin-left: 0px !important;
            }
        }
    }
    .yy-box-line {
        height: 1px;
        background: #ddd;
    }
}
</style>